/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na komunikátory univerzálního nastavení pro Ki-Wi Server.
 */
class CommunicatorSettingsFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<CommunicatorSettings>} CommunicatorSettings
   */
  constructor(CommunicatorSettings) {
    this.CommunicatorSettings = CommunicatorSettings;
  }

  /**
   * Vytvoří nový komunikátor nastavení.
   * @param {Object.<string, string>} [json] Část obsahu zařízení ze serveru s nastavením.
   * @returns {CommunicatorSettings}
   */
  create(json) {
    return new this.CommunicatorSettings(json);
  }
}

export default CommunicatorSettingsFactory;
